import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/header-img.svg";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);
  const toRotate = [ "Your ML Engineer ", "Your Deep Learning Engineer ", "Your Data Science guide" ];
  const period = 2000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => { clearInterval(ticker) };
  }, [text])

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex(prevIndex => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex(prevIndex => prevIndex + 1);
    }
  }

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <span className="tagline">Welcome to my Portfolio</span>
                <h1>{`Hi!  I'm Loki,`} <span className="txt-rotate" dataPeriod="1000" data-rotate='[ "Your ML Engineer", "Your DL Engineer", "Your Data Science guide" ]'><span className="wrap">{text}</span></span></h1>
                  <p> 
                  I am a Machine Learning Engineer and Data Science enthusiast with 3 years of experience in the field.
                  If you are looking for someone who is skilled, dedicated, and clear in communication, then you have come to the right place.
                  <br/>
                  </p>
                  <p> 
                    <h3>What can I do for you?</h3>
                    I specialize in building and training neural networks using TensorFlow, Keras, and PyTorch.
                    In addition, I can develop customized ML solutions to meet your specific business needs.
                    If you are a student or a beginner in Machine Learning or Deep Learning, I can provide you with guidance on subjects, assignments, or projects. My expertise in Natural Language Processing (NLP) and Computer Vision (CV) can help you leverage these technologies to gain insights from your data. Lastly, if you need data analysis or insights,
                    I can use Python to perform this task and provide you with actionable insights.
                  </p>
                  <br/>
                  <p>
                    <h3>My way:</h3>
                    I believe in delivering quality work on time, and I value my client's time and money.
                    To ensure that the project runs smoothly, I adopt a structured approach that includes understanding your requirements, building a customized solution, testing, and delivering a fully functional product.
                    Communication is key, and I believe in keeping my clients in the loop every step of the way.
                    <br/>
                    Don't hesitate to contact me if you're interested in working together. I'm confident that I can provide you with the solutions you need to succeed in your business or personal endeavors.
                  </p>
                  <br/>
      
                  {/* <button onClick={() => console.log('connect')}>Let’s Connect <ArrowRightCircle size={25} /></button> */}
              </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={headerImg} alt="Header Img"/>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
